import type { TFolder } from '@modules/items';
import { EFolderType } from '@modules/items/types/folders.types';
import type { TSparseOrganization } from '@modules/users';

export const isRegistrationsEnabled = (organization: TSparseOrganization): boolean =>
  organization.featureSettings.registrations?.enabled === true;

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/registrations/src/isRegistrationFolder.ts and the
// countries-root check in onFolderCreated.ts. A registration folder sits directly below a country of the root.
export const isRegistrationFolder = (folder: TFolder, organization: TSparseOrganization): boolean =>
  folder.folderType === EFolderType.COUNTRY &&
  folder.resolvedPath.length === 2 &&
  folder.resolvedPath[0]._id === organization.folders.countries;
